<template>
  <div :class="['widget-common', 'widget-full-height', sizeClass]">
    <div class="widget-title d-flex align-items-center justify-space-between">
      <div class="d-flex align-items-baseline">
        {{ label }}
        <i
          v-if="tooltip"
          v-tooltip="tooltipOptions"
          class="hi hi-info-filled ml-5"
          :title="tooltip"
        ></i>
      </div>
    </div>
    <div class="widget-body">
      <div
        v-for="item in items"
        :key="item.id"
        class="insights-ranking-widget-item"
      >
        <div class="details">
          <div class="info">
            <div class="main">
              <div class="percentage">{{ item.value }}%</div>
              <div
                ref="rankingItemName"
                v-tooltip="tooltipOptions"
                class="name"
                :data-original-title="item.name"
              >
                {{ item.name }}
              </div>
            </div>
            <AppProgressBar
              :tracked="valuePercentage(item, 100)"
              :total="100"
              :bar-color="barColor(item)"
              :bar-classes="barClasses(item)"
            />
          </div>
          <div
            v-if="!collapsed"
            class="time"
          >
            {{ timeSpent(item) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppProgressBar from '~/components/AppProgressBar.vue';
import { formatDuration } from '~/utils/time_utils';

export default {
  name: 'TopAppsAndUrlsWidget',
  components: {
    AppProgressBar,
  },
  props: {
    widgets: {
      type: Object,
      default: () => ({}),
    },
    topAppsAndUrls: {
      type: Array,
      default: () => [],
    },
    bodyClasses: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    tooltipOptions: Object.freeze({
      placement: 'top',
    }),
    tooltip: 'Most accessed apps & URLs during the selected time period',
    label: 'TOP APPS & URLS',
    widgetKey: 'categories',
    type: 'list',
    sizeClass: 'widget-medium',
    collapsed: false,
  }),
  computed: {
    items() {
      return this.topAppsAndUrls;
    },
  },
  methods: {
    hasActivity(item) {
      return item.activity !== undefined;
    },
    activityPercentage(item) {
      return `${Math.round(item.activity || 0 * 100)}%`;
    },
    valuePercentage(item, max) {
      const value = item.value || 0;

      return value ? (value * 100) / max : value;
    },
    barClasses(item) {
      let classes = 'insights-ranking';

      classes += ` ${classes}-${this.type}`;

      return classes;
    },

    barColor(item) {
      if (item.proficiency === 'core') {
        return '#2AA7FF';
      }
      if (item.proficiency === 'non_core') {
        return '#5C6A7B';
      }

      return '#F08050';
    },
    timeSpent(item) {
      return formatDuration(item.tracked, { showSeconds: 'never' });
    },
  },
};
</script>
